import "./Home.module.css";
import YujuBranding from "@/reusable_sections/Header";
import ThePowerSuiteHero from "./sections/ThePowerSuiteHero";
import OurCompassionateMission from "./sections/OurCompassionateMission";
import FromOurKitchenToYourTable from "./sections/FromOurKitchenToYourTable";
import TheBrewingRitual from "./sections/TheBrewingRitual";
import LoQueHemosConstruido from "./sections/LoQueHemosConstruido";
import LatestNewsAndActivities from "./sections/LatestNewsAndActivities";
import EntrustYourKeys from "./sections/EntrustYourKeys";
import BharatVidyaFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <YujuBranding />
      <ThePowerSuiteHero />
      <OurCompassionateMission />
      <FromOurKitchenToYourTable />
      <TheBrewingRitual />
      <LoQueHemosConstruido />
      <LatestNewsAndActivities />
      <EntrustYourKeys />
      <BharatVidyaFooter />
    </div>;
}